import React from 'react'
import { getImages } from '../Components/Common/const'
import HomeContact from '../Components/Home/HomeContact'
import SeoMeta from '../Components/Common/SeoMeta'
import { Helmet } from 'react-helmet'

const ContactUs = () => {
    return (
        <>
            <Helmet>
                <title>Contact Mercedes Showroom | Visit Us in Pompano Beach</title>
                <meta name="description" content="Reach out to our team at Mercedes Showroom. Call or visit our Pompano Beach location to learn more." />
                <meta name="keywords" content="" />
                <meta property="og:title" content="Contact Mercedes Showroom | Visit Us in Pompano Beach" />
                <meta property="og:description" content="Reach out to our team at Mercedes Showroom. Call or visit our Pompano Beach location to learn more." />
            </Helmet>
            <section className='common-wrap d-flex align-items-center' style={{ backgroundImage: `url(${getImages('contact-hero-bg.webp')})` }}>
                <div className='w-100'>
                    <div className='container'>
                        <h1 className='xl-title text-uppercase text-center wow reveal fadeInUp'>Contact</h1>
                        <h2 className='lg-title text-uppercase text-center fw-500 mt-3 mb-3 wow reveal fadeInUp'>Enjoy a pleasurable <br className='d-md-none' />buying experience</h2>
                    </div>
                </div>
            </section>
            <HomeContact cls="contact-form-wrap" />
        </>
    )
}

export default ContactUs